YP.HandsontableManager = function() {
    var Handsontable                = window.Handsontable;
    var handsonContainer            = document.getElementById('handsontable-attendees');
    var handsontableMaxRow          = handsonContainer.getAttribute("data-limit");
    var handsonCountRow             = document.getElementById('handsontable-count-row');

    var errorContainer              = $('#handsontable-errors');
    var errorList                   = errorContainer.find('ul#handsontable-errors-row');
    var duplicateList               = errorContainer.find('ul#handsontable-duplicate-row');
    var duplicateRow                = new Map();

    return {
        initContactManager: function () {
            this.columns = this.getContactColumns();
            this.initContactHandsontable(this.columns);
        },
        initExhibitContactManager: function (invitationMode, ticketTypes) {
            this.columns = this.getContactColumns();
            if (invitationMode === 'REGISTRATION_CODE') {
                this.columns.set(
                    "Nombre de codes d'inscription *",
                    {
                        data: 'quota',
                        type: 'numeric',
                        colWidths: 100,
                        allowInvalid: false,
                        allowEmpty: false,
                        numericFormat: {
                            pattern: '0'
                        },
                    }
                );
            } else if (invitationMode === 'DIRECT') {
                for(i = 0; i < ticketTypes.length; i++) {
                    this.columns.set(
                        `Nombre d\'invitation ${ticketTypes[i].name} *`,
                        {
                            data: `ticket_type_${ticketTypes[i].id}`,
                            type: 'numeric',
                            colWidths: 100,
                            allowInvalid: false,
                            allowEmpty: false,
                            numericFormat: {
                                pattern: '0'
                            },
                            formatOutput: ((typeTicketId, quota) => JSON.stringify({
                                'ticket_type_id': typeTicketId,
                                'quota': quota,
                            })).bind(null, ticketTypes[i].id),
                        }
                    );
                }
            }
            this.initContactHandsontable(this.columns);
        },
        initInvitationCodeManager: function () {
            this.columns = this.getContactColumns();
            this.columns.set(
                'Quota *',
                {
                    data: 'quota',
                    type: 'numeric',
                    colWidths: 100,
                    allowInvalid: true,
                    allowEmpty: false,
                    numericFormat: {
                        pattern: '0'
                    }
                }
            );
            this.columns.set(
                'Max. par commande',
                {
                    data: 'maximum_selectable',
                    type: 'numeric',
                    colWidths: 100,
                    allowInvalid: true,
                    allowEmpty: true,
                    numericFormat: {
                        pattern: '0'
                    }
                }
            );
            this.initContactHandsontable(this.columns);
        },
        initInvitationCodeImportManager: function () {
            this.columns = new Map([
                [
                    'Libellé *',
                    {
                        data: 'name',
                        type: 'text',
                        colWidths: 200,
                    }
                ],
                [
                    'Code *',
                    {
                        data: 'code',
                        type: 'text',
                        colWidths: 200,
                        validator: (value, cb) => {
                            cb(/^[A-z0-9]+$/i.test(value));
                        },
                    }
                ],
                [
                    'Quota',
                    {
                        data: 'quota',
                        type: 'numeric',
                        colWidths: 100,
                        allowInvalid: true,
                        allowEmpty: true,
                        numericFormat: {
                            pattern: '0'
                        }
                    }
                ],
                [
                    'Limite de sélection',
                    {
                        data: 'maximum_selectable',
                        type: 'numeric',
                        colWidths: 100,
                        allowInvalid: true,
                        allowEmpty: true,
                        numericFormat: {
                            pattern: '0'
                        }
                    }
                ]
            ]);
            this.initContactHandsontable(this.columns);
        },
        getCleanedData: function() {
            const cleanedData = (this.handsontable?.getData() ?? []).map((row) => {
                const arrayColumns = Array.from(this.columns.values());
                return row.map((cell, index) => {
                    return arrayColumns[index]?.formatOutput?.(cell) ?? cell ?? null;
                });
            });
            return cleanedData;
        },
        initContactHandsontable: function(columnMap) {
            if(!handsontableMaxRow || handsontableMaxRow >= 500) {
                handsontableMaxRow = 500;
            }
            const self = this;
            var handsonSettings = {
                data: getContactData.call(this),
                stretchH: 'last',
                columns: Array.from(columnMap.values()),
                colHeaders: Array.from(columnMap.keys()),
                afterChange: function(index, amount) {
                    if(handsonCountRow) {
                        countRows = this.countRows() - this.countEmptyRows();
                        handsonCountRow.innerText = countRows.toString();
                    }
                    $('input.handsontable_json').val(JSON.stringify(
                        self.getCleanedData.call(self),
                    )).trigger('change');
                },
                afterValidate: function(isValid, value, row, prop, source) {
                    //Increment row number to handle header row
                    row++;
                    errorList.find('li[data-row='+row+']').remove();
                    if(isValid === false) {
                        pushErrorMessage(errorList, row, value);
                    } else if(prop == "email_address" ) {
                        duplicateList.html('');
                        if(value !== "") {
                            var duplicate = this.getDataAtCol(2).reduce(function(a, e, i) {
                                if (e === value && i !== row - 1)
                                    a.push(i+1);
                                return a;
                            }, []);
                            if(duplicate.length) {
                                duplicate.push(row);
                                duplicateRow.set(value, duplicate)
                            }

                            duplicateRow.forEach(function(v, k) {
                                if(v.includes(row) && k !== value) {
                                    v.splice(v.indexOf(row), 1);
                                    duplicateRow.set(k, v);
                                }
                                if(v.length > 1) {
                                    errorMessage = "L'adresse " + k + " est présente aux <b>lignes " + v + "</b>";
                                    pushErrorMessage(duplicateList, row, value, errorMessage);
                                }
                            });
                        }
                    }
                    handleErrorList();
                },
                maxRows: handsontableMaxRow,
                autoWrapRow: true,
                height: 420,
                width: 800,
                startRows: 15,
                rowHeaders: true
            };
            this.handsontable = new Handsontable(handsonContainer, handsonSettings);
            // Trim whitespace from pasted data.
            // See : https://github.com/handsontable/handsontable/issues/3930#issuecomment-400763785
            this.handsontable.addHook("beforePaste", data => {
                for (let i = 0; i < data.length; i++) {
                    for (let j = 0; j < data[i].length; j++) {
                        data[i][j] = data[i][j].trim();
                    }
                }
            });
            const preventDefaultSubmit = (e) => {
                e.preventDefault();
                var _self = $(e.target);
                this.handsontable.deselectCell();
                $('input.handsontable_json').val(JSON.stringify(this.handsontable.getData()));
                setTimeout(function(e){_self.unbind("submit").submit();}, 300);
            }
            function getContactData() {
                var columns = this.getContactColumns();
                var data = $.parseJSON($('.handsontable_json').val());
                if(data) {
                    var newData = [];
                    for(i = 0; i < data.length; i++) {
                        d = {};
                        y = 0;
                        columns.forEach(function(v) {
                            d[v.data] = data[i][y];
                            y++;
                        });
                        newData.push(d);
                    }
                    return newData;
                }
            }
            function pushErrorMessage(errorContainer, row, value, errorMessage) {
                if(!errorMessage) {
                    errorMessage = '<b>Ligne ' + row + ' :</b> Valeur ' + value + ' non valide.';
                }
                errorContainer.append($('<li>', {
                    'html'    : errorMessage,
                    'data-row': row
                }));
                errorContainer.find('li').sort(function(a, b) {
                    return +a.dataset.row - +b.dataset.row;
                })
                .appendTo(errorContainer);
            }
            function handleErrorList() {
                var form      = $('form');
                var submitBtn = form.find(":submit");
                if(errorList.find('li').length == 0 && duplicateList.find('li').length == 0) {
                    errorContainer.hide();
                    submitBtn.removeAttr('disabled');
                } else {
                    errorContainer.show();
                    submitBtn.attr('disabled', 'disabled');
                }
            }

            $("form[name='invitation_code']").on("submit", preventDefaultSubmit);

            if(handsontableMaxRow > 15) {
                var $addRowBtn    = '<a id="handsontable-add-row" style="z-index:99999;position:relative;float:right;margin-top:10px;" class="btn-flat white"><i class="fa fa-plus"></i> Ajouter une ligne</a>';
                $($addRowBtn).insertAfter($('#handsontable-attendees'));

                var handsonAddRow = document.getElementById('handsontable-add-row');
                if(handsonAddRow) {
                    handsonAddRow.addEventListener('click', () => {
                        this.handsontable.alter("insert_row");
                        if(this.handsontable.countRows() >= handsontableMaxRow) {
                            $( "#handsontable-add-row" ).remove();
                        }
                        this.handsontable.selectCell(this.handsontable.countRows() - 1, 0);
                    }, false);
                }
            }
        },
        getContactColumns: function () {
            var kvColumns = [
                [
                    "Nom",
                    {
                        data: 'last_name',
                        type: 'text',
                        colWidths: 150,
                        validator: function (value, callback) {
                            r = /^[A-Za-zÀ-ÖØ-öø-ÿĀ-žȘșȚțŒœŠšŸ-ž' -]+$/;
                            if (value === '' || r.test(value)) {
                                callback(true);
                            } else {
                                callback(false);
                            }
                        },
                        allowInvalid: true,
                        allowEmpty: false,
                    }
                ],
                [
                    "Prénom",
                    {
                        data: 'first_name',
                        type: 'text',
                        colWidths: 150,
                        validator: function (value, callback) {
                            r = /^[A-Za-zÀ-ÖØ-öø-ÿĀ-žȘșȚțŒœŠšŸ-ž' -]+$/;
                            if (value === '' || r.test(value)) {
                                callback(true);
                            } else {
                                callback(false);
                            }
                        },
                        allowInvalid: true,
                        allowEmpty: false,
                    }
                ],
                [
                    "Adresse mail *",
                    {
                        data: 'email_address',
                        type: 'text',
                        colWidths: 200,
                        validator: function (value, callback) {
                            r = /^[A-Za-z0-9](([_\.\-]?[a-zA-Z0-9]+)*)@([A-Za-z0-9]+)(([\.\-]?[a-zA-Z0-9]+)*)\.([A-Za-z]{2,})$/;
                            if (value === '' || r.test(value)) {
                                callback(true);
                            } else {
                                callback(false);
                            }
                        },
                        allowInvalid: true,
                        allowEmpty: false,
                    },
                ]
            ];
            return new Map(kvColumns);
        },
    };
};
